import { render } from "./OfficialList.vue?vue&type=template&id=0bf78a9a&scoped=true"
import script from "./OfficialList.vue?vue&type=script&lang=js"
export * from "./OfficialList.vue?vue&type=script&lang=js"

import "./OfficialList.vue?vue&type=style&index=0&id=0bf78a9a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0bf78a9a"

export default script